import { journalModuleConfigDefault } from '@infotech/energy-link-front-core'
import {
  moduleCrudConfig,
  CRUDRoute,
  defaultModuleConfig,
} from './CRUDConfig'

const journalModuleConfig = {
  ...journalModuleConfigDefault,
  moduleCrudConfig,
  CRUDRoute,
  defaultModuleConfig,
}

export default journalModuleConfig
